import { TYPOGRAPHY_COLORS } from 'constants/TypographyColors'
import { SVGIcon } from './SvgIcon/SvgIcon'
import { IconProps } from './types'

export const ArrowBottomIcon = ({
  size,
  color = 'grey400',
  className,
  rotate,
  dataTestId,
}: IconProps) => (
  <SVGIcon
    size={size}
    rotate={rotate}
    viewBox="0 0 16 16"
    color={color}
    className={className}
    dataTestId={dataTestId}
  >
    <path
      d="M12.6663 5.66699L7.99968 10.3337L3.33301 5.66699"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SVGIcon>
)
